import { Button } from "@tql/ui-components-react/tql/buttons";
import { useNavigate } from "react-router";

export const ConstructionButton = () => {
	const navigate = useNavigate();

	return (
		<Button
			onClick={() => {
				navigate(-1);
			}}
		>
			Go Back
		</Button>
	);
};
